// extracted by mini-css-extract-plugin
export default {"grid":"ly2AhK","cell":"fXEdPx","label":"wj8OFT"};